import React from "react";
import Header from "./../Common/Header";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";
import "../Elements/styles/Contact.scss";

var bnrimg = require("./../../images/banner/1.png");

class ContactUs extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content">
          <Banner
            title="Delivering the right service at the right moment — your satisfaction is our priority."
            pagename="Contact Us"
            bgimage={bnrimg}
          />

          {/* SECTION CONTENTG START */}
          <div className="section-full p-tb80 inner-page-padding">
            {/* LOCATION BLOCK*/}
            <div className="container">
              {/* GOOGLE MAP & CONTACT FORM */}
              <div className="section-content">
                {/* CONTACT FORM*/}
                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <div className="contact-info m-b30">
                      {/* TITLE START */}
                      <div className="section-head">
                        <div className="mt-separator-outer separator-left">
                          <div className="mt-separator">
                            <h2 className="text-uppercase sep-line-one ">
                              <span className="font-weight-300 text-primary">
                                Contact
                              </span>{" "}
                              Info
                            </h2>
                          </div>
                        </div>
                      </div>
                      {/* TITLE END */}
                      <div
                        className="bg-gray p-a20 text-black"
                        style={{ borderRadius: 15 }}
                      >
                        <div className="mt-icon-box-wraper left">
                          <div className="icon-content">
                            <h5 className="m-t20 font-weight-500 social-title">
                              Follow & Contact Us
                            </h5>

                            <div className="social-grid">
                              {/* Instagram */}
                              <a
                                href="https://www.instagram.com/jit2_026/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-icon instagram"
                              >
                                <i className="fa fa-instagram" />
                                <span>Instagram</span>
                              </a>

                              {/* WhatsApp */}
                              <a
                                href="https://wa.me/919047885552"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-icon whatsapp"
                              >
                                <i className="fa fa-whatsapp" />
                                <span>WhatsApp</span>
                              </a>

                              {/* Facebook */}
                              <a
                                href="https://www.facebook.com/profile.php?id=61585420591906"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-icon facebook"
                              >
                                <i className="fa fa-facebook" />
                                <span>Facebook</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="mt-icon-box-wraper left p-b40">
                          <div className="icon-xs">
                            <i className="fa fa-phone" />
                          </div>
                          <div className="icon-content">
                            <h5 className="m-t0 font-weight-500">
                              Phone number
                            </h5>
                            <p>+91 90478 85552</p>
                          </div>
                        </div>
                        <div className="mt-icon-box-wraper left p-b40">
                          <div className="icon-xs">
                            <i className="fa fa-envelope" />
                          </div>
                          <div className="icon-content">
                            <h5 className="m-t0 font-weight-500">
                              Email address
                            </h5>
                            <p>jit.services13@gmail.com</p>
                          </div>
                        </div>
                        <div className="mt-icon-box-wraper left">
                          <div className="icon-xs">
                            <i className="fa fa-map-marker" />
                          </div>
                          <div className="icon-content">
                            <h5 className="m-t0 font-weight-500">
                              Address info
                            </h5>
                            <p>
                              No.20, Salai Road, Big Sowrashtra Street, Woraiyur
                              Main Road, Trichy - 620003
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="gmap-outline">
                <div>
                  <iframe
                    src="https://www.google.com/maps?q=No.20,+Salai+Road,+Big+Sowrashtra+Street,+Woraiyur+Main+Road,+Trichy+-+620003&output=embed"
                    width="100%"
                    height="400"
                    title="Just In Time Company Location Map - Trichy"
                    style={{ border: 0, borderRadius: 15 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
          {/* SECTION CONTENT END */}
        </div>

        <Footer />
      </>
    );
  }
}

export default ContactUs;
